<template>
  <section class="rev-ras-banner-with-cta-module-component">
    <div class="rr-container">
      <div
        v-if="data.add_top_divider"
        class="divider-container">
        <BicolorLine
          :full="true"
          left="approachable"
          right="progressive" />
      </div>

      <div class="content">
        <div class="image-container">
          <img
            v-if="data.image"
            :src="data.image.url"
            :alt="data.image.alt" />
        </div>

        <div class="text-container">
          <div
            class="text"
            v-html="data.content"></div>
          <div class="button-container">
            <ButtonGlobal
              v-if="data.button"
              :text="data.button.title"
              :target="data.button.target"
              :url="data.button.url" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "RevRASBannerWithCTAComponent",
  "CLASSNAME": "rev-ras-banner-with-cta-module-component",
  "URL": "http://vuevitewp.local/test"
 }
#ENDMETA */

/*
 * Insert your logic here
 */
import ButtonGlobal from '@/components/utility/ButtonGlobal.vue'
import BicolorLine from '@/components/utility/BicolorLine.vue'
import useFooterBackgroundClass from '@/components/composables/useFooterBackgroundClass.js'
const props = defineProps(['data'])

const balancedFooterClass = 'balanced-footer'

useFooterBackgroundClass(
  balancedFooterClass,
  () => props.data?.update_footer_background
)
</script>

<style lang="scss" scoped>
.rev-ras-banner-with-cta-module-component {
  @apply bg-balanced pt-10 pb-[80px] lg:pb-[68px] lg:pt-2;

  .divider-container {
    @apply mb-[40px] lg:mb-[50px];
  }

  .content {
    @apply flex flex-col gap-[28px] lg:flex-row lg:gap-10;

    .image-container {
      @apply relative w-full h-full lg:w-full lg:max-w-[543px] lg:h-[282px];

      img {
        @apply w-full h-full object-cover rounded-[27px];
      }
    }

    .text-container {
      @apply flex flex-col justify-center gap-5 mt-5 lg:gap-12 lg:mt-0;

      .text {
        :deep(h2),
        :deep(h3),
        :deep(h4),
        :deep(h5),
        :deep(h6) {
          @apply header-2 text-white;
        }

        :deep(p) {
          @apply text-white text-[18px] leading-[28px] lg:text-[20px] lg:leading-[30px];
        }
      }
    }
  }
}
</style>

<style lang="scss">
body.balanced-footer .site-footer {
  background: #1e6b5c !important;
}
</style>
